import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getAllSections(_obj, params) {
    const res = await axios.get(`api/application-forms/section/`, { params });
    return res.data;
  },

  async getSection(_obj, id) {
    const res = await axios.get(`api/application-forms/section/${id}/`);
    return res.data;
  },

  async createSection(_obj, data) {
    return axios.post(`api/application-forms/section/`, data);
  },

  async updateSection(_obj, { id, data }) {
    return axios.patch(`api/application-forms/section/${id}/`, data);
  },

  async deleteSection(_obj, id) {
    return axios.delete(`api/application-forms/section/${id}/`);
  },
  async getQuestionCount(_obj, data) {
    return (await axios.post(`api/application-forms/section/question-count/`, data)).data.data;
  },
  async getPublicSections(_obj, params) {
    const res = await axios.get(`api/application-forms/section/public-section-list/`, { params });
    return res.data;
  }
};

export const sections = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
